<template>
    <div class="timeline-container">
        <div class="label">
            <div class="row">
                <p>{{ label }}</p>
                <div class="legend">
                    <div class="item">
                        <div class="square"></div>
                        <p>werkuren</p>
                    </div>
                    <div class="item">
                        <div class="square break"></div>
                        <p>pauzes</p>
                    </div>
                    <div class="item">
                        <div class="square overtime"></div>
                        <p>meer tijd nodig dan voorzien</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="timeline">
            <timeline-section
                v-for="(interval, index) in intervals"
                :interval="interval"
                :key="'interval' + index"
                :width="intervalWidth(interval)"></timeline-section>
            <div class="indications" v-if="fullHours">
                <div
                    class="indication"
                    v-for="(fullHour, index) in fullHours"
                    :key="'productTimelineFullHour' + index"
                    :style="'left: ' + getWidthFromStart(fullHour) + '%'">
                    <span class="hour">{{ fullHour.format('HH:mm') }}</span>
                </div>
            </div>
            <div class="indications" v-if="halfHours">
                <span
                    class="indication halfHour"
                    v-for="(halfHour, index) in halfHours"
                    :key="'productTimelineHalfHour' + index"
                    :style="
                        'left: ' + getWidthFromStart(halfHour) + '%'
                    "></span>
            </div>
        </div>
    </div>
</template>
<script>
import TimelineSection from './TimelineSection.vue';

export default {
    props: {
        intervals: {
            type: Array,
            required: true,
        },
        workIntervals: {
            type: Array,
            required: true,
        },
        label: {
            type: String,
            required: false,
        },
        start: {
            type: Object,
            required: true,
        },
        end: {
            type: Object,
            required: true,
        },
    },
    computed: {
        totalDuration() {
            const difference = this.end.diff(this.start, 'seconds');

            if (difference === 0) {
                return this.getIntervalDuration(this.workIntervals[0]);
            }

            return difference;
        },
        fullHours() {
            const startRoundedUp = this.start.clone();

            // Round up to nearest hour | Add one minute to force 8am to 9am for example
            startRoundedUp.add(1, 'minute');
            startRoundedUp.minute() ||
            startRoundedUp.second() ||
            startRoundedUp.millisecond()
                ? startRoundedUp.add(1, 'hour').startOf('hour')
                : startRoundedUp.startOf('hour');

            const amountOfHours = this.end.diff(startRoundedUp, 'hours');

            let hours = [startRoundedUp];

            for (let i = 1; i < amountOfHours; i++) {
                hours.push(startRoundedUp.clone().add(i, 'hour'));
            }

            return hours;
        },
        halfHours() {
            const startRoundedUp = this.start.clone();

            // Round up to nearest hour | Add one minute to force 8am to 9am for example
            startRoundedUp.add(1, 'minute');
            startRoundedUp.minute() > 30 ||
            startRoundedUp.second() ||
            startRoundedUp.millisecond()
                ? startRoundedUp.add(1, 'hour').startOf('hour').minutes(30)
                : startRoundedUp.startOf('hour').minutes(30);

            const amountOfHours = this.end.diff(startRoundedUp, 'hours');

            let halfHours = [startRoundedUp];

            for (let i = 1; i <= amountOfHours; i++) {
                halfHours.push(startRoundedUp.clone().add(i, 'hour'));
            }

            return halfHours;
        },
    },
    methods: {
        intervalWidth(interval) {
            return (
                (this.getIntervalDuration(interval) / this.totalDuration) * 100
            );
        },
        getIntervalDuration(interval) {
            return interval.end.diff(interval.start, 'seconds');
        },
        getWidthFromStart(date) {
            const difference = date.diff(this.start, 'seconds');
            return (difference / this.totalDuration) * 100;
        },
    },
    components: {
        TimelineSection,
    },
};
</script>
